import { Tooltip, Space, Popconfirm, Image, Tag, Popover } from "antd";
import {
  EditTwoTone,
  DeleteTwoTone,
  MailTwoTone,
  HddTwoTone,
} from "@ant-design/icons";
import { COLOR_PRIMARY } from "..";
import get from "lodash/get";
import map from "lodash/map";

export const companyColumns = (toggleCompanyForm, onDeleteCompany) => [
  {
    title: "Logo",
    key: "logo",
    render: (record) => {
      return <Image width={70} src={get(record, "logo.url")} />;
    },
  },
  {
    title: "Company",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    render: (text) => (
      <div
        style={{
          maxWidth: "27vw",
        }}
      >
        {text}
      </div>
    ),
  },
  {
    title: "Details",
    key: "id",
    render: (record) => {
      return (
        <Space size="middle">
          <Tag color={get(record, "show_sochiot_logo") ? "green" : "red"}>
            SochIOT Logo :{" "}
            {get(record, "show_sochiot_logo") ? "Enabled" : "Disabled"}
          </Tag>

          <Popover
            placement="bottom"
            title={"Contact emails"}
            content={
              <div>
                {map(get(record, "contact_emails", []), (email, index) => (
                  <p key={index}>{email}</p>
                ))}
              </div>
            }
          >
            <MailTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
            />
          </Popover>

          <Popover
            placement="bottom"
            title={"Templates"}
            content={
              <div>
                {map(get(record, "template_access_list", []), (template, index) => (
                  <p key={index}>{get(template, "name")}</p>
                ))}
              </div>
            }
          >
            <HddTwoTone style={{ fontSize: 20 }} twoToneColor={COLOR_PRIMARY} />
          </Popover>
        </Space>
      );
    },
  },
  {
    title: "Action",
    key: "id",
    render: (record) => {
      return (
        <Space size="middle">
          <Tooltip title="Edit Company">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                toggleCompanyForm(record, true);
              }}
            />
          </Tooltip>

          <Tooltip title="Delete Company">
            <Popconfirm
              title="Delete the Company"
              description="Are you sure to delete this Company?"
              onConfirm={() => {
                onDeleteCompany(get(record, "id"));
              }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteTwoTone
                style={{ fontSize: 20 }}
                twoToneColor={COLOR_PRIMARY}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      );
    },
  },
];
